import ShareMsgBase from './A_G.ShareMsgBase';

class MsgMissionsComplete extends ShareMsgBase {
  /**
   * The message that gets sent when you finish the daily mission and you want to brag
   * @param {string} user1AvatarURL
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1AvatarURL, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(245, 43, user1AvatarURL, 0, 195, null);
    this.bg = this._addExtImage(0, 0, 'img/Share_Missions_Complete.png', 0, null, null);
  }
}

G.MsgMissionsComplete = MsgMissionsComplete;
